angular
  .module('quote')

  .factory('QuoteCountersCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class QuoteCountersCrud extends Crud {
        constructor() {
          super(
            '',
            '@@apiUrl' + '/quotes-counters' + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: false
              }
            }
          );
        }
      }
      return QuoteCountersCrud;
    }
  ]);
